import SRP from './SRP';

export default SRP;



// WEBPACK FOOTER //
// ./src/components/SRP/index.js